"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OauthPayloadOut = void 0;
class OauthPayloadOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return OauthPayloadOut.attributeTypeMap;
    }
}
exports.OauthPayloadOut = OauthPayloadOut;
OauthPayloadOut.discriminator = undefined;
OauthPayloadOut.attributeTypeMap = [
    {
        "name": "channel",
        "baseName": "channel",
        "type": "string",
        "format": ""
    },
    {
        "name": "error",
        "baseName": "error",
        "type": "string",
        "format": ""
    },
    {
        "name": "incomingWebhookUrl",
        "baseName": "incomingWebhookUrl",
        "type": "URI",
        "format": "uri"
    }
];
//# sourceMappingURL=OauthPayloadOut.js.map